import { TopBar } from '@shopify/polaris';
import UserTopBarElement from '../../features/session/UserTopBarElement';
import LogoSuffix from '../logoSuffix/LogoSuffix';

const topBar = (
  <TopBar logoSuffix={<LogoSuffix />} userMenu={<UserTopBarElement />} />
);

export default topBar;
